import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Caption1, Dialog } from "@activecollab/components";
import PropTypes from "prop-types";
import { WorkWeekHours } from "~/components/Settings/WorkWeekHours";
import { validateWorkWeekHours } from "~/utils/utils";

export const ChangeWorkweekCapacityDialog = ({ open, onClose, days, content, handleSubmitWorkweekCapacityChange }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState(days);

  useEffect(() => {
    setValues(days);
  }, [days]);

  const onChange = useCallback((days) => setValues(days), []);

  const handleSubmit = useCallback(() => {
    handleSubmitWorkweekCapacityChange(values);
    onClose();
  }, [handleSubmitWorkweekCapacityChange, onClose, values]);

  const workWeekHoursValidator = useCallback((v) => validateWorkWeekHours(v, 1), []);

  return (
    <Dialog
      enableBackgroundClick
      open={open}
      onClose={onClose}
    >
      <Dialog.Title>{t("Change Workdays")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content className="tw-flex-col tw-items-start tw-space-y-4">
        {content}
        {values.length > 0 ? (
          <div className="tw-flex-col tw-items-start tw-gap-2 tw-self-stretch">
            <WorkWeekHours
              days={values}
              onChange={onChange}
              isValid={workWeekHoursValidator}
            />
            <Caption1
              color="tertiary"
              className="tw-mt-2"
            >
              {t("Enter a value that ends in either .00, .25, .5, or .75.")}
            </Caption1>
          </div>
        ) : null}
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        <Button
          type="submit"
          variant="primary"
          className="tw-mr-3"
          disabled={values.length > 0 && values.some((day) => !day.isValid)}
          onClick={handleSubmit}
        >
          {t("Update")}
        </Button>
        <Button
          type="button"
          onClick={onClose}
          variant="secondary"
        >
          {t("Cancel")}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

ChangeWorkweekCapacityDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  days: PropTypes.array,
  removedDays: PropTypes.array,
  content: PropTypes.element,
  handleSubmitWorkweekCapacityChange: PropTypes.func,
};

ChangeWorkweekCapacityDialog.defaultProps = {
  open: false,
  onClose: () => null,
};
